module.exports = __webpack_public_path__ + "static/index/img/baikal-303.475bd53a.jpg";